const priceContracts: {cakeAddress: string, busdAddress: string, lpAddress:string} = {
  cakeAddress: '0x5c46c55a699a6359e451b2c99344138420c87261',
  busdAddress: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  lpAddress: '0x36B8eE5c1f8FFB3b224736Ca9c989B1c531a613d'
}

export default priceContracts